import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField, KTSVG} from 'helpers'
import {OrganizationTypeList} from 'models/dropdown'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {IOrgMapping} from 'models/UserManagement'
import {
 createOrgMapping,
 fetchUserOrgMappingList,
 fetchOrganisationTypes,
 fetchOrgMappingList,
 removeUserOrgMappingManageUser,
} from 'utils/api/auth/userManagementService'
import {toast} from 'react-toastify'
import {KTSearchBox} from 'helpers/ui-components/KTSearchBox'
import {Link} from 'react-router-dom'
import {KTConfirmPopup} from 'helpers/ui-components/KTConfirmPopup'
import {KTFilterBox} from 'helpers/ui-components/KTFilterBox'
import {fetchFilterConfig} from 'utils/api/auth/commonService'
import {createFilterPayload} from 'utils/helpers/genericFilterForm'
// import {ILogin} from 'models/Auth'
type IProps = {
 accessDetails: IFormField | undefined
 userDetails?: IFormField | null
 userRole: number
 loggedInUserId: number | undefined
 setLoader: (newState: boolean) => void
}

type FormValues = {
 selectedIds: string[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NetworkMapping = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)
 const [currentPage, setCurrentPage] = useState(1)
 const [totalRecord, setTotalRecord] = useState(0)
 const [searchTerm, setSearchTerm] = useState('')
 const [showAddNewBtn, setShowAddNewBtn] = useState(false)
 const [onPageLoad, setOnPageLoad] = useState(true)
 const [itemsPerPage, setItemsPerPage] = useState(25)
 const [confirmModalData, setConfirmModalData] =
  useState<IOrgMapping | null>(null)
 const [selectedCategory, setSelectedCategory] =
  useState('all')
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<IOrgMapping>>
 >([])
 const [categoryList, setCategoryList] = useState<
  OrganizationTypeList[]
 >([])
 const [assignedOrgMapping, setAssignedOrgMapping] =
  useState<IOrgMapping[]>([])
 const [orgMappingTableRows, setOrgMappingTableRows] =
  useState<IOrgMapping[]>([])
 const {register, watch, handleSubmit, setValue} =
  useForm<FormValues>({
   mode: 'all',
   reValidateMode: 'onChange',
   defaultValues: {selectedIds: []},
  })
 const [filterParam, setFilterParam] = useState<string>('')
 const userId = props.userDetails?.id
 const [filterFormData, setFilterFormData] = useState({})
 const [filterConfig, setFilterConfig] = useState<
  IFormField[]
 >([])
 const [filterCount, setFilterCount] = useState(0)
 const [showTypeFilter, setShowTypeFilter] = useState(false)
 const [showOfftakerType, setShowOfftakerType] =
  useState(false)
 const getOrgMapping = async (
  page: Number,
  param?: string,
  orgMapping?: IOrgMapping[]
 ) => {
  props.setLoader(true)

  const payload = await createFilterPayload(
   filterConfig,
   filterFormData
  )
  setShowAddNewBtn(false)
  setFilterCount(payload.totalAppliedFilters)
  const mapping = orgMapping ?? assignedOrgMapping
  const res = await fetchOrgMappingList({
   page,
   user_id: userId,
   page_size: itemsPerPage,
   type:
    selectedCategory === 'all'
     ? filterParam || param
     : selectedCategory,
   ...(searchTerm && {search: searchTerm}),
   ...payload,
  })
  if (res) {
   const orgList: IOrgMapping[] = res.results
   const hasOfftakerType = orgList.some((item) =>
    Object.prototype.hasOwnProperty.call(
     item,
     'offtaker_type'
    )
   )
   setShowOfftakerType(hasOfftakerType)
   setTotalRecord(mapping.length + (res.count ?? 0))
   if (page === 1) {
    setOrgMappingTableRows([...mapping, ...orgList])
   } else {
    setOrgMappingTableRows(orgList)
   }
  }
  props.setLoader(false)
 }

 const getUserOrgMapping = async () => {
  props.setLoader(true)
  // let assigendForOthers: string[] = []
  const assigendForOwn: string[] = []
  const res = await fetchUserOrgMappingList({
   user_id: userId,
  })
  if (res) {
   const orgList: IOrgMapping[] = []
   res.map((val: IFormField) => {
    if (val?.organisation) {
     assigendForOwn.push(val.organisation.id.toString())
    }
    orgList.push({
     ...val.organisation,
     org_mapping_id: val.id,
     is_mapped: true,
     mapped_users: [props.userDetails],
    })
   })
   setOnPageLoad(false)
   setShowAddNewBtn(true)
   //  setValue('selectedIds', assigendForOwn)
   setValue('selectedIds', [])
   setTotalRecord(orgList.length ?? 0)
   setAssignedOrgMapping(orgList)
   setOrgMappingTableRows(orgList)
  }
  props.setLoader(false)
 }

 const getFilterConfigs = async () => {
  const res = await fetchFilterConfig({
   filter_type: 'USER',
   filter_key: 'ORGANISATION_MAPPING_FILTERS',
  })

  if (res) {
   setFilterConfig(res?.applicableFilters ?? [])
  }
 }

 useEffect(() => {
  void getFilterConfigs()
 }, [])

 const handleDeleteBtnClick = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   const record: IOrgMapping | null = confirmModalData
   if (record) {
    props.setLoader(true)
    const mapping = assignedOrgMapping.filter(
     (rec) => rec.id !== record.id
    )
    const res = await removeUserOrgMappingManageUser({
     user_org_mapping_ids: [record.org_mapping_id],
    })
    if (res) {
     // mapping.splice(index, 1)
     setAssignedOrgMapping(mapping)
     if (!(onPageLoad || showAddNewBtn)) {
      await getOrgMapping(currentPage, '', mapping)
     } else {
      setOrgMappingTableRows(mapping)
      setTotalRecord(mapping.length ?? 0)
     }
    }
    props.setLoader(false)
    setConfirmModalData(null)
   }
  } else {
   setConfirmModalData(null)
  }
 }

 const renderTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IOrgMapping>> = [
   {
    key: 'name',
    title: t(
     'userManagement.activate.networkMapping.orgName'
    ),
   },
   {
    key: 'district',
    title: t(
     'userManagement.activate.networkMapping.location'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.networkMapping.orgType'
    ),
    render: (_, record) => {
     return record?.category?.name
    },
   },
   ...(showOfftakerType
    ? [
       {
        key: 'offtaker_type',
        title: 'Offtaker Type',
        render: (_: unknown, record: IOrgMapping) => {
         return record?.offtaker_type ?? '-'
        },
       },
      ]
    : []),
   {
    key: 'currentlyAssignedTo',
    title: t(
     'userManagement.activate.networkMapping.currentlyAssignedTo'
    ),
    render: (_, record) => {
     return record?.mapped_users?.[0] ? (
      <Link
       target='_blank'
       rel='noreferrer'
       className='w-full text-[#4E83E4] underline'
       to={`/user-details/${record?.mapped_users[0]?.id}`}
      >
       {record?.mapped_users[0]?.full_name}
      </Link>
     ) : (
      <span className='text-[#C5CED6]'>
       {t('userManagement.activate.geoMapping.notAssigned')}
      </span>
     )
    },
   },
   ...(!isDisabled
    ? [
       {
        key: 'action',
        title: t(
         'userManagement.activate.geoMapping.action'
        ),
        className: '!text-center',
        render: (
         _: ColumnProps<IOrgMapping>,
         record: IOrgMapping
        ) => {
         const disabled = record?.mapped_users?.[0]?.id
          ? true
          : false
         return (
          <div
           className='w-full flex justify-center items-center'
           key={record?.id}
          >
           {record?.is_mapped ? (
            <Button
             type='button'
             disabled={false}
             onClick={() => {
              void setConfirmModalData(record)
             }}
             color='green'
             className='text-center bg-white !rounded-lg text-[#CC293F] text-xs font-semibold border-none shadow-none'
            >
             <i
              className='fa fa-trash text-lg font-normal'
              aria-hidden='true'
             ></i>
             <span className='ml-2 pt-1'>
              {t('userManagement.activate.remove')}
             </span>
            </Button>
           ) : (
            <div
             className={`${
              disabled && 'text-[#C5CED6] border-[#E6EBF0]'
             } flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
     shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
            >
             <CheckboxField
              type='checkbox'
              disabled={disabled}
              label={''}
              className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
              wrapperClassName=''
              defaultChecked={disabled}
              value={record.id.toString()}
              name={`selectedIds`}
              id={`selectedIds-${record.id}`}
              register={register(`selectedIds`, {
               required: false,
              })}
             />
             <span
              className={`${
               disabled && 'text-[#C5CED6]'
              } text-base font-semibold ml-1`}
             >
              {disabled ||
              (watch(`selectedIds`).length > 0 &&
               watch(`selectedIds`)?.includes(
                record.id.toString()
               ))
               ? t(
                  'userManagement.activate.geoMapping.added'
                 )
               : t(
                  'userManagement.activate.geoMapping.add'
                 )}
             </span>
            </div>
           )}
          </div>
         )
        },
       },
      ]
    : []),
  ]
  setTableColList(columns)
  props.setLoader(false)
 }

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getOrgMapping(pageNo)
 }

 async function submitFormData(formData: IFormField) {
  if (formData?.selectedIds?.length > 0) {
   props.setLoader(true)
   const payload = {
    user_id: userId,
    organisation_ids: formData.selectedIds,
   }
   const res = await createOrgMapping(payload)
   if (res) {
    toast.success(res)
    await getUserOrgMapping()
   }
   props.setLoader(false)
  } else {
   toast.error(t('errors.pleaseSelectOrg'))
  }
 }

 const handleEditBtnClick = () => {
  if (props.accessDetails?.activationFlow?.canEdit) {
   setIsDisabled(false)
  }
 }

 useEffect(() => {
  const getCategories = async () => {
   props.setLoader(true)
   const res: OrganizationTypeList[] =
    await fetchOrganisationTypes(
     props.userDetails?.user_category_key
      ? {
         user_category_key:
          props.userDetails.user_category_key,
        }
      : undefined
    )
   if (res?.length > 1) {
    const paramString = res
     .map((item) => item.key)
     .join(',')
    setShowTypeFilter(true)
    setFilterParam(paramString)
    setCategoryList([
     {
      key: 'all',
      display_name: 'All',
     },
     ...res,
    ])
   } else if (res?.length === 1) {
    setShowTypeFilter(false)
    setFilterParam(res[0].key)
    setCategoryList([])
   } else {
    setShowTypeFilter(false)
    setFilterParam('')
    setCategoryList([])
   }
   props.setLoader(false)
  }
  void getCategories()
 }, [])
 useEffect(() => {
  if (currentPage !== 1) {
   setCurrentPage(1)
  }
  if (onPageLoad) {
   void getUserOrgMapping()
  } else {
   void getOrgMapping(1)
  }
 }, [
  selectedCategory,
  searchTerm,
  itemsPerPage,
  onPageLoad,
  filterFormData,
 ])

 useEffect(() => {
  void renderTableData()
 }, [orgMappingTableRows, isDisabled])

 return (
  <>
   {confirmModalData && (
    <KTConfirmPopup
     showConfirmModel={confirmModalData ? true : false}
     handleConfirmBtnClick={handleDeleteBtnClick}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.deleteConfirmModalSubTitle')} ${
      confirmModalData.name
     }?`}
    />
   )}
   <div className='w-full'>
    <div>
     {t('userManagement.activate.networkMapping.title')}
    </div>
    <KTSearchBox
     label={t('userManagement.activate.search')}
     placeholder={t(
      'userManagement.activate.networkMapping.searchText'
     )}
     wrapperClass='my-6 !p-3'
     setSearchTerm={setSearchTerm}
    />
    <KTFilterBox
     parentId='organisation'
     btnText={t('helperText.filter')}
     containerClass='flex-wrap items-start gap-y-2'
     filterConfig={filterConfig}
     setLoader={props.setLoader}
     filterCount={filterCount}
     filterFormData={filterFormData}
     setFilterFormData={(data) => {
      setFilterFormData(data)
      setCurrentPage(1)
     }}
    >
     {showTypeFilter && (
      <div className='ml-4 flex min-w-0 flex-1 flex-wrap items-center gap-x-6 gap-y-2'>
       {categoryList.map((val, key) => (
        <div
         key={key}
         onClick={() => {
          setSelectedCategory(val.key)
         }}
         className={`text-center py-[6px] px-2 rounded-lg text-sm border font-normal cursor-pointer
        ${
         selectedCategory === val.key
          ? 'bg-[#33393D] text-white border-[#33393D]'
          : 'bg-white text-[#33393D] border-[#CED8E0] hover:bg-[#33393D] hover:text-white'
        }`}
        >
         {val.display_name}
        </div>
       ))}
      </div>
     )}
    </KTFilterBox>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='text-[#171B1F] flex justify-end text-lg font-normal'>
      {props.accessDetails?.activationFlow?.canEdit &&
       orgMappingTableRows?.length >= 0 &&
       (isDisabled ? (
        <Button
         key={'edit'}
         type='button'
         disabled={false}
         onClick={handleEditBtnClick}
         color='blue'
         className='text-center py-[9px] px-6 hover:bg-[#4E83E4] w-[85px]
                       !rounded-lg text-base text-[#4E83E4] hover:text-white font-semibold border-[#4E83E4]'
        >
         {t('common.edit')}
        </Button>
       ) : (
        <Button
         key={'save'}
         type='submit'
         disabled={watch(`selectedIds`).length === 0}
         color='blue'
         className='text-center py-[9px] px-6 bg-[#4E83E4] 
                       !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
        >
         {t('common.save')}
        </Button>
       ))}
     </div>
     <div className='w-full'>
      <div className='w-full mt-2'>
       <KTTable
        data={orgMappingTableRows}
        columns={tableColList}
        headerClass='bg-[#80868C]'
        headerColClass='!border-0 text-left'
        colClass='text-[#33393D] !text-sm font-normal !border-0'
        tableClass=''
        rowClass='even:bg-[#E6EBF0]'
        showPagination={true}
        currentPage={currentPage}
        totalRecord={totalRecord}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
       />
       {!isDisabled && showAddNewBtn && !onPageLoad && (
        <div className='border-[#E6EBF0] border-[0.5px] py-3 px-4 flex items-center w-full mt-2'>
         <div
          className='flex text-[#4E83E4] text-base font-medium items-center cursor-pointer'
          onClick={() => {
           void getOrgMapping(1)
          }}
         >
          <KTSVG
           path={`/media/icons/plus.svg`}
           svgClassName={`w-5 h-5`}
          />
          <div>
           {t(
            'userManagement.activate.networkMapping.addNew'
           )}
          </div>
         </div>
        </div>
       )}
      </div>
     </div>
    </form>
   </div>
  </>
 )
}

export default NetworkMapping
